module.exports = __webpack_public_path__ + "static/img/3.8634a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/3.jpg
// module id = 421
// module chunks = 1